__turbopack_context__.v({
  "imgOverlay": "T3LhGq_imgOverlay",
  "link": "T3LhGq_link",
  "tileContainer": "T3LhGq_tileContainer",
  "tileLayout": "T3LhGq_tileLayout",
  "title": "T3LhGq_title",
});
